import type { DealAssistantUnavailableReason } from './state/DealAssistantContext';

export const DEAL_ASSISTANT_CHAT_PATH = '/ai/assistant/chat';

// The 35 s limit is a total deadline on purpose. P0 is buffered AG-UI only. When streaming lands we can revisit it then.
export const DEAL_ASSISTANT_REQUEST_TIMEOUT_MS = 35000;

export const DEAL_ASSISTANT_FAILURE_MESSAGE = "Sorry, I couldn't get an answer. Please try again.";

export const DEAL_ASSISTANT_MONITORING_EVENTS = {
    openPanel: 'MVDealAssistant OpenPanel',
    inputInteraction: 'MVDealAssistant InputInteraction',
    welcomeLinkClick: 'MVDealAssistant WelcomeLinkClick',
    sendMessage: 'MVDealAssistant SendMessage',
    sendFailed: 'MVDealAssistant SendFailed',
    dealStructureFailed: 'MVDealAssistant DealStructureFailed',
    dealStructureSkipped: 'MVDealAssistant DealStructureSkipped',
    snapshotFailed: 'MVDealAssistant SnapshotFailed'
} as const;

export const DEAL_ASSISTANT_ENTRY_LABEL = 'Ask Deal AI';

export const DEAL_ASSISTANT_ENTRY_PROMPTS = ['Search inventory', 'Find alternative vehicles'] as const;

export const DEAL_ASSISTANT_ENTRY_PROMPT_INTERVAL_MS = 4500;

export const DEAL_ASSISTANT_UNAVAILABLE_LABELS: Record<DealAssistantUnavailableReason, string> = {
    loading: 'Loading the deal…',
    calculating: 'Updating payments…',
    'payment-failed': 'Payment could not be calculated',
    'missing-inputs': 'Finish the deal to ask Deal AI',
    'no-context': 'Finish the deal to ask Deal AI'
};

export const DEAL_ASSISTANT_PANEL_TITLE = 'Deal AI';

export const DEAL_ASSISTANT_PANEL_PLACEHOLDER = 'Ask AI';

export const DEAL_ASSISTANT_WELCOME_TEXT = 'I can help with this deal. Choose an option:';

export const DEAL_ASSISTANT_WELCOME_LINKS = ['Alternative Vehicles', 'Search Inventory'] as const;

export const DEAL_ASSISTANT_LOADING_LABEL = 'Deal AI is thinking';

export const DEAL_ASSISTANT_TYPING_DELAY_MS = 400;
